import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "./trpc";

export function useProtectMerchant() {
  const trpc = useProtectTRPC();
  const { merchant } = useMerchant();
  const rentalsMerchantId = merchant?.id ?? "";

  const { data, isPending } = useQuery({
    ...trpc.merchants.get.queryOptions({ rentalsMerchantId }),
    enabled: !!rentalsMerchantId,
    staleTime: 60_000,
    retry: false,
  });

  return {
    protectMerchant: data ?? null,
    isLoading: !rentalsMerchantId || isPending,
  };
}
